module.exports = __webpack_public_path__ + "img/ICE_logo_black.d41d8cd9.svg";